import { mapActions, mapGetters } from "vuex";

export const linkRobMixin = {
  computed: {
    ...mapGetters({
      linkIsLoading: "link/create/isLoading",
      delIsLoading: "link/del/isLoading",
    }),
  },
  methods: {
    ...mapActions({
      createLink: "link/create/create",
      deleteLink: "link/del/del",
    }),
  },
};
